import Humanize from 'humanize-plus';

// Helper function to handle document deletion
const handleDelete = (doc, containerName, contextType) => {
    // This would need to be implemented based on your application's requirements
    console.log(`Delete document: ${doc.name} from ${contextType} ${containerName}`);
    // You would typically call an API here to delete the document
};

// New List View Component
export const DocList = ({ docs, showDelete, containerName, contextType }) => {
    if (!docs || docs.length === 0) {
        return <div className="alert alert-info mt-3">No documents available.</div>;
    }

    return (
        <div className="table-responsive">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '60px' }}>Format</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Created Date</th>
                        <th>Expiry Date</th>
                        <th>Size</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {docs.map((doc, index) => {
                        return (
                            <tr key={index}>
                                <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                    {doc.documentFormat && doc.documentFormat.icon ? (
                                        <i className={`fas ${doc.documentFormat.icon} fa-2x`}></i>
                                    ) : (
                                        <i className="fas fa-file fa-2x"></i>
                                    )}
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>{doc.title}</td>
                                <td style={{ verticalAlign: 'middle' }}>{doc.documentType?.documentType || 'Unknown'}</td>
                                <td style={{ verticalAlign: 'middle' }}>{doc.documentType?.description || 'No Description'}</td>
                                <td style={{ verticalAlign: 'middle' }}>{new Date(doc.created).toLocaleDateString()}</td>
                                <td style={{ verticalAlign: 'middle' }}>{new Date(doc.expiry).toLocaleDateString()}</td>
                                <td style={{ verticalAlign: 'middle' }}>{Humanize.fileSize(doc?.size || 0)}</td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <div className="btn-group">
                                        <a 
                                            href={doc.pathIncludingSasToken} 
                                            target="_blank" 
                                            rel="noreferrer" 
                                            className="btn btn-sm btn-primary"
                                        >
                                            <i className="fas fa-eye"></i>
                                        </a>
                                        <a 
                                            href={doc.pathIncludingSasToken} 
                                            download 
                                            className="btn btn-sm btn-success"
                                        >
                                            <i className="fas fa-download"></i>
                                        </a>
                                        {showDelete && (
                                            <button 
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDelete(doc, containerName, contextType)}
                                            >
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};